<template>
    <div class="row">
        <transition name="slide-left">
            <div v-if="showSideMenu" class="position-absolute bg-white pl-3 w-100 side-menu-mobile">
                <go-lotus-side-menu
                    :side-menu-items="menuItems"
                    @set-parent-prop="propSetFromChild($event)"
                >
                </go-lotus-side-menu>
            </div>
        </transition>
        <go-lotus-side-menu :side-menu-items="menuItems"> </go-lotus-side-menu>
        <div class="col-12 col-sm-9 col-md-10">
            <div class="p-3">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "../GoLotusSideMenu";
import { sideMenuItems } from "../../plugins/sideMenuItems";

export default {
    name: "SideMenuWrapper",
    mixins: [sideMenuItems],
    components: { GoLotusSideMenu },
};
</script>

<style scoped></style>
